import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainAdvanced from "./MainAdvanced";
import ViewFirmware from "./ViewFirmware";
import ViewUpdates from "./ViewUpdates";
import ViewServers from "./ViewServers";
import FormServer from "./servers/FormServers";
import ViewMQTT from "./ViewMQTT";
import FormMQTTBasic from "./MQTT/FormMQTTBasic";
import FormMQTTAdvanced from "./MQTT/FormMQTTAdvanced";
import ViewNTP from "./ViewNTP";
import FormNTP from "./NTP/FormNTP";
import ViewGPS from "./ViewGPS";
import FormGPS from "./GPS/FormGPS";
import ViewConfigs from "./ViewConfigs";
import ViewSender from "./ViewSender";
import RoutesPGA460 from "./PGA460/RoutesPGA460";
import ViewGlobalMap from "./ViewGlobalMap";

const RoutesAdvanced = () => {
    return (
        <>
            <Route
                path="advanced"
                element={
                    <PrivateRoute role="superuser">
                        <MainAdvanced />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/firmware"
                element={
                    <PrivateRoute role="superuser">
                        <ViewFirmware />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/updates"
                element={
                    <PrivateRoute role="superuser">
                        <ViewUpdates />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/networks"
                element={
                    <PrivateRoute role="superuser">
                        <ViewServers />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/network/:id"
                element={
                    <PrivateRoute role="superuser">
                        <FormServer />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/mqtt"
                element={
                    <PrivateRoute role="superuser">
                        <ViewMQTT />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/mqtt/basic/:id"
                element={
                    <PrivateRoute role="superuser">
                        <FormMQTTBasic />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/mqtt/advanced/:id"
                element={
                    <PrivateRoute role="superuser">
                        <FormMQTTAdvanced />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/ntp"
                element={
                    <PrivateRoute role="superuser">
                        <ViewNTP />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/ntp/:id"
                element={
                    <PrivateRoute role="superuser">
                        <FormNTP />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/gps"
                element={
                    <PrivateRoute role="superuser">
                        <ViewGPS />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/gps/:id"
                element={
                    <PrivateRoute role="superuser">
                        <FormGPS />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/configs"
                element={
                    <PrivateRoute role="superuser">
                        <ViewConfigs />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/sender"
                element={
                    <PrivateRoute role="superuser">
                        <ViewSender />
                    </PrivateRoute>
                }
            />
            <Route
                path="advanced/globalmap"
                element={
                    <PrivateRoute role="superuser">
                        <ViewGlobalMap />
                    </PrivateRoute>
                }
            />
            {RoutesPGA460()}
        </>
    );
};
export default RoutesAdvanced;
